module.exports = __webpack_public_path__ + "static/farmyard2-61cc1b8ff09d1c8a21ca30ac20124ac3.png";